import { useQuery } from "react-query";

import { GET_MATCHING_SESSIONS_BY_DATES } from "constants/reactQueryKeys";
import { getPerpetualWeeklyEvents } from "api/clinicians";
/** @typedef {import("react-query").UseQueryResult} UseQueryResult */

/**
 * Custom hook to fetch Matching sessions by dates.
 *
 * @param {Object} details - The details object containing startDate, endDate, and clinicianId.
 * @param {number|string} details.clinicianId - The clinician ID to fetch the matching sessions for.
 * @param {number[]|string[]} details.clientIds - The client IDs to fetch the matching sessions for.
 * @returns {UseQueryResult} - The result of the useQuery hook.
 */
const useGetMatchingSessions = ({ clientIds, clinicianId }) => {
  const queryDetails = { clientIds, clinicianId };

  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_MATCHING_SESSIONS_BY_DATES, clinicianId, clientIds.join(",")],
    () => getPerpetualWeeklyEvents(queryDetails),
    {
      enabled: Boolean(clinicianId),
      refetchOnWindowFocus: false,
    }
  );

  return {
    recurrentEventsParent: data?.data || null,
    isEventsLoading: isLoading,
    refetchRecurrentEvents: refetch,
    ...rest,
  };
};

export default useGetMatchingSessions;
